<script lang="ts" setup>
import { Experiment } from '@ts-types/experiments/enums'
import { Experiments } from '@tools/Experimenter/src'
import { computed, defineAsyncComponent, provide } from 'vue'
// constants
import config from '@config/experiments.json'
// components
const AfterSchoolQuiz = defineAsyncComponent(() => import('@views/AfterSchoolQuiz/ViewAfterSchoolQuiz.vue'))
const AfterSchoolQuizReading = defineAsyncComponent(() => import('@views/AfterSchoolQuiz/ViewAfterSchoolQuizReading.vue'))

defineOptions({
  name: 'ViewAfterSchoolQuiz'
})

const experimenter = new Experiments(config)

const afterschoolQuiz5163 = experimenter.getExperimentBranch(Experiment.AfterschoolQuiz5163)
const afterschoolQuiz5610 = experimenter.getExperimentBranch(Experiment.AfterschoolQuiz5610)
const AfterschoolQuiz5795 = experimenter.getExperimentBranch(Experiment.AfterschoolQuiz5795)

const experiments = {
  [Experiment.AfterschoolQuiz5163]: afterschoolQuiz5163.value,
  [Experiment.AfterschoolQuiz5610]: afterschoolQuiz5610.value,
  [Experiment.AfterschoolQuiz5795]: AfterschoolQuiz5795.value,
}

provide('experiments', experiments)

const isAfterschoolQuiz5163 = computed(() => experiments[Experiment.AfterschoolQuiz5163] === 'test')

</script>

<template>
  <AfterSchoolQuizReading
    v-if="isAfterschoolQuiz5163"
  />
  <AfterSchoolQuiz
    v-else
  />
</template>
